<template>
  <section class="payments-list-view">
    <div class="card">
      <div class="card-header">
        <div class="card-header-title">Pagamentos</div>
      </div>
      <div class="card-content">
        <b-table
          id="table-payments"
          :data="data"
          :total="total"
          :paginated="false"
          :per-page="perPage"
          :current-page.sync="page"
          :loading.sync="isLoading"
          :pagination-simple="false"
          :pagination-rounded="false"
          aria-previous-label="Página Anterior"
          aria-current-label="Página Atual"
          aria-next-label="Próxima Página"
          aria-page-label="Página"
        >
          <b-table-column v-slot="props" field="receiver" label="Recebedor">
            <p>{{ props.row.referrer.name }}</p>
          </b-table-column>

          <b-table-column
            v-slot="props"
            field="total_conversions"
            label="Total de conversões"
          >
            <p>{{ props.row.total_conversions }}</p>
          </b-table-column>

          <b-table-column v-slot="props" field="total_amount" label="Valor">
            <p>{{ props.row.total_amount | currency("BRL") }}</p>
          </b-table-column>

          <b-table-column
            v-slot="props"
            field="reference_month"
            label="Mês de referência"
          >
            <p>{{ props.row.reference_month }}</p>
          </b-table-column>

          <b-table-column
            v-slot="props"
            field="payment_status"
            label="Status do pagamento"
          >
            <p>
              {{
                props.row.payment_status === 1 ? "Pago" : "Aguardando pagamento"
              }}
            </p>
          </b-table-column>

          <b-table-column v-slot="props" field="paid_at" label="Pago em">
            <p v-if="props.row.paid_at">
              {{ props.row.paid_at | date("DD/MM/YYYY") }}
            </p>
            <p v-else>Aguardando pagamento</p>
          </b-table-column>

          <b-table-column v-slot="props" label="Opções" width="110">
            <b-tooltip label="Visualizar detalhes" class="m-1">
              <b-button
                @click="() => onPayPaymentClick(props.row)"
                type="is-dark"
                size="is-small"
                icon-right="eye"
              />
            </b-tooltip>
          </b-table-column>

          <template #footer v-if="total > 0">
            <div class="row align-middle text-center pagination-container">
              <div
                class="col-5 col-lg-5 col-md-5 col-sm-3 ptext text-right"
              ></div>

              <div class="col-auto text-center">
                <b-pagination
                  aria-controls="table-payments"
                  v-model="page"
                  :per-page="perPage"
                  :total-rows="total"
                  first-number
                  last-number
                >
                </b-pagination>
              </div>

              <div class="col-auto text-center">
                <b-select
                  class="pselect"
                  v-model="perPage"
                  style="margin-left: 10px"
                >
                  <b-select-option
                    v-for="i in perPageOptions"
                    :key="i"
                    :value="i"
                  >
                    <b>{{ i }}</b>
                  </b-select-option>
                </b-select>
              </div>
            </div>
          </template>

          <template slot="empty">
            <section class="section">
              <div class="content has-text-grey has-text-centered">
                <p>Nenhum registro encontrado.</p>
              </div>
            </section>
          </template>
        </b-table>
      </div>
    </div>
  </section>
</template>

<script>
import ReferralProgramService from "../../../services/referral-program.service";
import PaymentConfirmation from "./PaymentConfirmation.vue";

export default {
  data: () => ({
    perPageOptions: [10, 20, 40, 80],
    isLoading: false,
    perPage: 10,
    data: [],
    total: 0,
    page: 1,
  }),
  watch: {
    page() {
      this.loadPayments();
    },
    perPage() {
      this.loadPayments();
    },
  },
  methods: {
    loadPayments() {
      this.isLoading = true;

      ReferralProgramService.getPayments({
        page: this.page,
        per_page: this.perPage,
      })
        .then(({ data }) => {
          const { data: items, total } = data;

          this.total = total;
          this.data = items ?? [];
        })
        .catch(() => {
          this.$buefy.snackbar.open("Erro ao carregar pagamentos.");
        })
        .finally(() => (this.isLoading = false));
    },
    onPayPaymentClick(payment) {
      this.$buefy.modal.open({
        parent: this,
        component: PaymentConfirmation,
        hasModalCard: true,
        trapFocus: true,
        canCancel: true,
        props: {
          payment,
        },
        events: {
          close: (reload) => {
            reload && this.loadPayments();
          },
        },
      });
    },
  },
  mounted() {
    this.loadPayments();
  },
};
</script>

<style lang="scss">
.pagination-container {
  justify-content: end;
  margin-right: 10px;
}
</style>
